import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar } from "@/components/ui/calendar";
import { CalendarDays } from "lucide-react";

interface VehicleCollectionCalendarProps {
  selectedDate: Date | undefined;
  onDateSelect: (date: Date | undefined) => void;
  isDateAvailable: (date: Date) => boolean;
}

const VehicleCollectionCalendar: React.FC<VehicleCollectionCalendarProps> = ({
  selectedDate,
  onDateSelect,
  isDateAvailable,
}) => {
  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 text-lg">
          <CalendarDays className="w-5 h-5 text-honeycomb" />
          Choose Your Date
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-center">
          <Calendar
            weekStartsOn={1}
            mode="single"
            selected={selectedDate}
            onSelect={onDateSelect}
            disabled={(date) => !isDateAvailable(date) || date < new Date()}
            className="rounded-md border-0"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default VehicleCollectionCalendar;
